import 'isomorphic-fetch';

import requestTimeout from './request-timeout';
import Request from './request';
import * as Sentry from '@sentry/browser';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import moLogin, { toggleLogin } from '@store/login';

const abortController = new AbortController();
const { signal } = abortController;

const apiPost = (requestURL: string, body: object, second: number = 200000) => {
  return Promise.race([
    requestTimeout(second),
    Request('post', requestURL, signal, body),
  ]).then((response): Promise<null> => {
    // 返回格式 response.json(), .text(), .blob(), .formData(), .arrayBuffer()
    // @ts-ignore
    if (response.status === 200 || response.code === 0) return response.json();
    // if (response.code === 0) return response.json();
    // @ts-ignore
    // throw response.json();
    console.log('[apiPost] Response status:', response.status);
    // @ts-ignore
    return response.json();

    // 接口请求超时，中断请求
    // abortController.abort();
    // throw 'timeout';
  }).then((data: any) => {
    // 只记录诊断元数据，避免登录响应中的 Token、授权码或用户信息落盘。
    console.log('[apiPost] Parsed response metadata:', {
      type: typeof data,
      code: typeof data?.code === 'number' ? data.code : undefined,
      hasResult: data?.result !== undefined,
      hasAccessToken: Boolean(data?.access_token),
    });
    if (data.code !== 0) {
      if (data.code === 5) {
        console.log('后台错误');
        // changeErrorTyppe();
        Sentry.captureException(data.msg);
        toast.error(data.msg, {
          theme: 'dark',
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
          draggable: false,
          pauseOnFocusLoss: false,
        });
      }
      if (data.code === -5) {
        console.log('请登录');
        Cookies.remove('access_token');
      }
      if (data.code === 2) {
        // changeErrorTyppe();
        console.log('后台逻辑错误');
        Sentry.captureException(data.msg);
      }
      if (data.code.toString()[0] === '4') {
        Cookies.remove('access_token');
        // localforage.clear().then(() => {});
        toggleLogin(true);
      }
    }
    return data;
  }).catch((err: Error) => {
    console.error('[apiPost] Request error:', err);
    return { code: -999, msg: err.message };
  }).finally(() => {
    // Maybe do something
    // console.log('--- done --- ');
  });
};

export default apiPost;
